import { Ptag } from "components/core";
import React, { useMemo } from "react";
import {
  AgeGridWrapper,
  Divider,
  DividerHidden,
  SumInsuredHeaderWrapper,
  TopRightImage,
} from "./styles";
import { joinWithAndComma, newFormatRupees } from "utlis/utils";
import SumInsuredHeaderDetail from "./SumInsuredHeaderDetail";
import useUser from "hooks/useUser";
import { useNavigate } from "react-router";
// import planSumSubImg from "../../../assets/svgs2026/Frame.svg";
import planSumSubImg from "../../../assets/images2026/Frame.png";

function SumInsuredHeader({ sumInsured, dependents ,defaultSumInsured, min, max}) {
  const { getRole } = useUser();
  const isAdmin = getRole() === "admin";
  const navigate = useNavigate();
  // const minSumInsured = useMemo(() => Math.min(...sumInsured), [sumInsured]);
  // const maxSumInsured = useMemo(() => Math.max(...sumInsured), [sumInsured]);

//   const minSumInsured = useMemo(() => {
//   const numericValues = sumInsured.filter(
//     (val) => !isNaN(val) && val !== ""
//   );
//   // console.log(numericValues);

//   return numericValues.length
//     ? Math.min(...numericValues.map(Number))
//     : sumInsured[0];
// }, [sumInsured]);

// const maxSumInsured = useMemo(() => {
//   const numericValues = sumInsured.filter(
//     (val) => !isNaN(val) && val !== ""
//   );

//   return numericValues.length
//     ? Math.max(...numericValues.map(Number))
//     : sumInsured[sumInsured.length - 1];
// }, [sumInsured]);

  const minSumInsured = useMemo(() => min, [min]);
  const maxSumInsured = useMemo(() => max, [max]);
  console.log("Min", minSumInsured, "Max", maxSumInsured);

  const sumInsuredFormatted = useMemo(() => {
    if (minSumInsured == null && maxSumInsured == null) {
    return newFormatRupees(defaultSumInsured);
  }
    if (minSumInsured === maxSumInsured) return newFormatRupees(minSumInsured);
    return `${newFormatRupees(minSumInsured)} - ${newFormatRupees(maxSumInsured)}`;
  }, [minSumInsured, maxSumInsured]);

  const dependentsCovered = useMemo(
    () => joinWithAndComma(dependents?.covered), 
    [dependents]
  );

  const renderAgeGrid = (min, max) => (
    <>
      <AgeGridWrapper>
        <Ptag fontFamily="Montserrat" fontSize="16px" fontWeight="400" color="rgba(255, 255, 255, 1)" style={{ width: "fit-content", whiteSpace: "nowrap"}}>
          Min Age:{" "}
        </Ptag>
        <Ptag fontFamily="Montserrat" fontSize="18px" fontWeight="600" color="rgba(255, 255, 255, 1)" style={{ width: "fit-content", whiteSpace: "nowrap"}}>
          {min} years{" "}
        </Ptag>
      </AgeGridWrapper>
      <AgeGridWrapper>
        <Ptag fontFamily="Montserrat" fontSize="16px" fontWeight="400" color="rgba(255, 255, 255, 1)" style={{ width: "fit-content", whiteSpace: "nowrap"}}>
          Max Age:{" "}
        </Ptag>
        <Ptag fontFamily="Montserrat" fontSize="18px" fontWeight="600" color="rgba(255, 255, 255, 1)" style={{ width: "fit-content", whiteSpace: "nowrap"}}>
          {max} years{" "}
        </Ptag>
      </AgeGridWrapper>
    </>
  );

 

  return (
    <SumInsuredHeaderWrapper isMultiline={minSumInsured !== maxSumInsured}>
      <img src={planSumSubImg} alt="planSumSubImg" className="planSummarySubImage" />
      <section style={{ display: "flex", flexDirection: "row", gap: "107px" }}>
        <div>
          <SumInsuredHeaderDetail
            title="Sum Insured"
            subtitleMinMax={minSumInsured !== maxSumInsured}
            defaultSumInsured={defaultSumInsured}
            min={newFormatRupees(minSumInsured)}
            max={newFormatRupees(maxSumInsured)}
            value={sumInsuredFormatted}
          />
        </div>
        {minSumInsured === maxSumInsured && dependentsCovered && dependentsCovered.trim() !== "" && <DividerHidden />}
        {dependentsCovered && dependentsCovered.trim() !== "" && (
          <SumInsuredHeaderDetail
            title="Dependents Covered"
            value={dependentsCovered}
          />
        )}
      </section>
      {/* {isAdmin && ( */}
      {(
        (dependents?.children?.count ||
          (dependents?.children?.age_limit?.length > 0) ||
          (dependents?.parental?.age_limit?.length > 0)
        ) && (
        <section>
          {dependents?.children?.count && (
            <SumInsuredHeaderDetail
              title="Max no.of Children"
              value={dependents?.children?.count}
            />
          )}
          
          {(dependents?.children?.age_limit?.[0] ||
            dependents?.children?.age_limit?.[1]) && (
            <SumInsuredHeaderDetail title="Children Age Limit">
              {renderAgeGrid(
                dependents?.children?.age_limit?.[0],
                dependents?.children?.age_limit?.[1]
              )}
            </SumInsuredHeaderDetail>
          )}
          {(dependents?.parental?.age_limit?.[0] ||
            dependents?.parental?.age_limit?.[1]) && (
            <SumInsuredHeaderDetail title="Parental Age Limit">
              {renderAgeGrid(
                dependents?.parental?.age_limit?.[0],
                dependents?.parental?.age_limit?.[1]
              )}
            </SumInsuredHeaderDetail>
          )}
        </section>
      ))}
     
    </SumInsuredHeaderWrapper>
  );
}

export default SumInsuredHeader;
